import { AbstractControl, ValidatorFn } from "@angular/forms";
import { BnMaskPipe } from "@bndes/bndes-ux4/bn-mask/bn-mask-pipe";

export const BN_MASK_NUMERO_PROCESSO: string = "9999999-99.9999.9.99.9999";

export class FormatoNumeroProcessoValidadtorFn {
  bnMask: BnMaskPipe;

  constructor(bnMask: BnMaskPipe) {
    this.bnMask = bnMask;
  }

  public validate(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      if (control.value) {
        // Grab all categories by spliting them after ;
        const numeroProcesso = this.bnMask.transform(
          control.value,
          BN_MASK_NUMERO_PROCESSO
        );

        if (!numeroProcesso.match("^\\d{7}-\\d{2}\\.(202[0-9]|20[3-9][0-9]|2[1-9][0-9]{2}|[3-9][0-9]{3})\\.\\d\\.\\d{2}\\.\\d{4}$")) {
          return { invalidFormat: true };
        }

        // Validation passed; To signal this we need to return null
        return null;
      }
    };
  }
}
